<template>
  <form @submit.prevent="updateProfile">
    <card>
      <h2 slot="header" class="card-title">{{$t('page_user.profile__title')}}</h2>
      <div class="row">
        <div class="col-lg-3">
          <h3 v-if="loggedUser.role === UserRoles.APPLICANT" class="card-title">{{$t('page_user.profile__title_project')}}</h3>
          <p>{{$t('page_user.profile__subtitle_project')}}</p>
          <base-input
            type="text"
            name="name"
            v-validate="'required'"
            :error="getError('name')"
            :label="$t('page_user.profile__name')"
            :placeholder="$t('page_user.profile__name')"
            v-model="model.profile.name"
          >
          </base-input>
          <input-phone
            v-model="model.profile.phone"
            name="phone"
            v-validate="'required'"
            :error="getError('phone')"
            :label="$t('page_user.profile__telephone')"
            :placeholder="$t('page_user.profile__telephone')"
          ></input-phone>
          <base-input
            type="text"
            v-model="model.profile.email"
            :label="$t('page_user.profile__email')"
          ></base-input>
          <div v-if="loggedUser.role !== UserRoles.ADMIN && model.profile.role !== UserRoles.APPLICANT" class="mt-4">
            <p v-if="model.profile.role">
              Your role is: <strong>{{model.profile.role.replace('_', ' ')}}</strong>
            </p>
            <div v-if="model.regions.length">
              <p>Your regions are:</p>
              <ul>
                <li v-for="region in model.regions" :key="region.regionId">
                  <strong>{{region.name}}</strong>
                </li>
              </ul>
            </div>
            <div v-if="model.countries.length">
              <p>Your countries are:</p>
              <ul>
                <li v-for="country in model.countries" :key="country.countryId">
                  <strong>{{country.name}}</strong>
                </li>
              </ul>
            </div>
            <div v-if="model.assignedApplications.length">
              <p>Your applications are:</p>
              <ul>
                <li v-for="application in model.assignedApplications" :key="application.applicationId">
                  <strong>{{application.reference}}</strong>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="loggedUser.role === UserRoles.ADMIN">
            <div class="form-group">
              <label for="roleSelect">{{$t('page_user.profile__role')}}</label> <select class="form-control"
                                                                                        :disabled="loggedUser.role !== UserRoles.ADMIN"
                                                                                        v-model="model.profile.role"
                                                                                        name="role"
                                                                                        :error="getError('role')"
                                                                                        v-validate="'required'"
            >
              <option :value="role" :selected="model.profile.role === role" v-for="role in UserRoles" :key="role">{{role.replace('_', ' ')}}</option>
            </select>
            </div>
              <base-input
                  type="password"
                  name="password"
                  :error="getError('password')"
                  :label="$t('page_user.profile__password')"
                  :placeholder="$t('page_user.profile__password')"
                  v-model="model.profile.password"
              >
              </base-input>
            <div v-if="model.profile.role !== UserRoles.APPLICANT" class="form-group" :class="{'has-danger': getError('model.regions')}">
              <div>
                <label for="regionSelect">{{$t('page_user.profile__region')}}</label>
                <multiselect name="model.regions" v-model="model.regions" selectLabel="" selectedLabel="" deselectLabel="Clear" v-validate="'required'" :data-vv-as="$t('page_user.profile__region')" :tag-placeholder="$t('general.please_select')" :placeholder="$t('general.please_select')" label="name" track-by="regionId" :options="regions" :multiple="true"></multiselect>
                <label v-if="getError('model.regions')" class="error text-danger">{{getError('model.regions')}}</label>
              </div>

              <div class="form-group">
                <div class="mt-2">
                  <label class="mb-2">Access level</label>
                </div>
                <base-radio class="mt-0" inline name="countries" v-model="model.access_type">Countries</base-radio>
                <base-radio class="mt-0" inline name="applications" v-model="model.access_type">Applications</base-radio>
              </div>

              <div v-if="model.access_type === 'countries'" class="mt-2">
                <label for="countrySelect">{{$t('page_user.profile__country')}}</label>
                <multiselect name="model.countries" v-model="model.countries" selectLabel="" selectedLabel="" deselectLabel="Clear" :tag-placeholder="$t('general.please_select')" :placeholder="$t('general.please_select')" label="name" track-by="countryId" :options="countriesByRegions" :multiple="true"></multiselect>
              </div>

              <div v-if="model.access_type === 'applications'" class="mt-2">
                <label for="applicationSelect">Applications</label>
                <multiselect name="model.assignedApplications" v-model="model.assignedApplications" selectLabel="" selectedLabel="" deselectLabel="Clear" :tag-placeholder="$t('general.please_select')" :placeholder="$t('general.please_select')" label="reference" track-by="applicationId" :options="applicationsByRegions" :multiple="true"></multiselect>
              </div>
            </div>

            <div class="mb-5"></div>
          </div>
        </div>
        <div v-if="model.profile.role === UserRoles.APPLICANT" class="col-lg-3">
          <h3 class="card-title">Organizational Details</h3>
          <div class="form-group">
            <label for="regionSelect">{{$t('page_user.profile__region')}}</label> <select class="form-control"
                                                                                          @change="setRegion"
                                                                                          name="region"
                                                                                          id="regionSelect"
                                                                                          :error="getError('region')"
                                                                                          v-validate="'required'"
          >
            <option value="" selected="selected">{{$t('general.please_select')}}</option>
            <option :value="region.regionId" :selected="model.fields.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
          </select> <label v-if="getError('region')" class="error text-danger">{{getError('region')}}</label>
          </div>
          <div class="form-group">
            <label for="countrySelect">{{$t('page_user.profile__country')}}</label> <select class="form-control"
                                                                                            @change="setCountry"
                                                                                            name="country"
                                                                                            id="countrySelect"
                                                                                            :error="getError('country')"
                                                                                            v-validate="'required'"
          >
            <option value="" selected="selected">{{$t('general.please_select')}}</option>
            <option :value="country.countryId" :selected="model.fields.countryId === country.countryId" v-for="country in countriesByRegion(model.fields.regionId)" :key="country.countryId">{{country.name}}</option>
          </select> <label v-if="getError('country')" class="error text-danger">{{getError('country')}}</label>
          </div>
          <base-input
            type="text"
            name="protected_area"
            v-validate="'required'"
            data-vv-as="protected area"
            :error="getError('protected_area')"
            :label="$t('page_user.profile__protected_area')"
            :placeholder="$t('page_user.profile__protected_area')"
            v-model="model.fields.protectedArea"
          >
          </base-input>
          <base-input
            type="text"
            name="organisation_legal_name"
            v-validate="'required'"
            data-vv-as="organisation legal name"
            :error="getError('organisation_legal_name')"
            :label="$t('page_user.profile__org_legalname')"
            :placeholder="$t('page_user.profile__org_legalname')"
            v-model="model.fields.organisationLegalName"
          >
          </base-input>
          <base-input
            type="text"
            name="organisation_short_name"
            :label="$t('page_user.profile__org_shortname')"
            :placeholder="$t('page_user.profile__org_shortname')"
            v-model="model.fields.organisationShortName"
          >
          </base-input>
          <base-input
            type="text"
            name="website"
            v-validate="'url'"
            data-vv-as="field"
            :error="getError('website')"
            :label="$t('page_user.profile__website')"
            :placeholder="$t('page_user.profile__website')"
            v-model="model.fields.website"
          >
          </base-input>
          <base-input
            type="text"
            name="mailing_address"
            v-validate="'required'"
            :error="getError('mailing_address')"
            data-vv-as="mailing address"
            :label="$t('page_user.profile__mailing')"
            :placeholder="$t('page_user.profile__mailing')"
            v-model="model.fields.mailingAddress"
          >
          </base-input>
          <base-input
            type="text"
            name="physical_address"
            v-validate="'required'"
            :error="getError('physical_address')"
            data-vv-as="physical address"
            :label="$t('page_user.profile__address')"
            :placeholder="$t('page_user.profile__address')"
            v-model="model.fields.physicalAddress"
          >
          </base-input>
        </div>
        <div v-if="model.profile.role === UserRoles.APPLICANT" class="col-lg-6">
          <h3 class="card-title">{{$t('page_user.profile__title_orgtype')}}</h3>
          <p>
            {{$t('page_user.profile__subtitle_orgtype')}}
          </p>
          <div class="mt-3"></div>
          <label v-if="getError('organisationType')" class="text-danger">{{getError('organisationType')}}</label>
          <radio name="organisationType"
                 inline
                 value="government_agency"
                 v-validate="'required'"
                 :data-vv-as="$t('general.field')"
                 v-model="model.fields.organisationType"
          >
            {{$t('page_user.profile__government_agency')}}
          </radio>
          <radio name="organisationType" inline value="protected_conserved_area" v-model="model.fields.organisationType">
            {{$t('page_user.profile__protected_conserved_area')}}
          </radio>
          <radio name="organisationType" inline value="civil_society_ngo" v-model="model.fields.organisationType">
            {{$t('page_user.profile__civil_society_ngo')}}
          </radio>
          <radio name="organisationType" inline value="local_community_cbo" v-model="model.fields.organisationType">
            {{$t('page_user.profile__local_community_cbo')}}
          </radio>
          <radio name="organisationType" inline value="small_medium_enterprise_sme" v-model="model.fields.organisationType">
            {{$t('page_user.profile__small_medium_enterprise_sme')}}
          </radio>
          <!-- <radio name="organisationType" inline value="european_member" v-model="model.fields.organisationType">
            {{$t('page_user.profile__european_member')}}
          </radio>
          <radio name="organisationType" inline value="oecd_member" v-model="model.fields.organisationType">
            {{$t('page_user.profile__oecd')}}
          </radio>
          <radio name="organisationType" inline value="regional_org" v-model="model.fields.organisationType">
            {{$t('page_user.profile__regional_org')}}
          </radio>
          <radio name="organisationType" inline value="international_org" v-model="model.fields.organisationType">
            {{$t('page_user.profile__international_org')}}
          </radio>
          <radio name="organisationType" inline value="other" v-model="model.fields.organisationType">
            {{$t('page_user.profile__other')}}
          </radio>
          <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('page_user.profile__other_specify')"
              v-model="model.fields.organisationTypeOther"
            >
            </textarea>
          </base-input>
          <p class="mt-2">{{$t('page_user.profile__organisation_type_note')}}</p> -->
        </div>
      </div>
      <base-button v-if="isEditable" native-type="submit" type="primary" size="lg" class="btn-fill">
        Save
      </base-button>
    </card>
  </form>
</template>
<script>
  import {ApplicationService, UserService, UserRoles, RegionService, LocalizationService} from '@/services';
  import InputPhone from '@/components/InputPhone';
  import {BaseRadio} from 'src/components';
  import Multiselect from 'vue-multiselect';

  export default {
    components: {
      InputPhone,
      Multiselect,
      BaseRadio
    },
    data() {
      return {
        UserRoles,
        regions: [],
        allApplicationsLight: [],
        countries: [],
        value: '',
        initialized: false,
        model: {
          access_type: 'countries',
          assignedApplications: [],
          profile: {},
          fields: {},
          regions: [],
          countries: []
        }
      };
    },
    props: {
      isEditable: {
        type: Boolean,
        default: true
      },
      userId: {
        type: [Number, String],
        default: null
      }
    },
    computed: {
      loggedUser() {
        return this.$store.getters['Auth/loggedUser'];
      },
      applicationsByRegions() {
        let vm = this;
        let applications = [];

        if (vm.model.regions) {
          vm.model.regions.forEach(function (region) {
            let filteredApplications = vm.allApplicationsLight.filter((_application) => {
              return _application.regionId === region.regionId;
            });
            applications = applications.concat(filteredApplications);
          })
        }

        if (vm.model.assignedApplications) {
          let removed_applications = [];
          vm.model.assignedApplications.forEach(function (application) {
            let filteredApplications = applications.filter((_application) => {
              return (_application.applicationId === application.applicationId);
            });

            if (!filteredApplications.length) {
              removed_applications.push(application);
            }
          })

          removed_applications.forEach(function (application) {
            let applicationIndex = vm.model.assignedApplications.indexOf(application);
            if (applicationIndex !== -1) {
              vm.model.assignedApplications.splice(applicationIndex, 1);
            }
          })
        }

        return applications;
      },
      countriesByRegions() {
        let vm = this;
        if (!vm.initialized) {
          return [];
        }
        let countries = [];

        if (vm.model.regions) {
          vm.model.regions.forEach(function (region) {
            let regionCountries = vm.countriesByRegion(region.regionId);
            countries = countries.concat(regionCountries);
          })
        }

        countries = countries.sort(function (a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();

          return textA.localeCompare(textB);
        })

        if (vm.model.countries) {
          let removed_countries = [];
          vm.model.countries.forEach(function (country) {
            let filteredCountry = countries.filter((_country) => {
              return _country.countryId === country.countryId;
            });

            if (!filteredCountry.length) {
              removed_countries.push(country);
            }
          })

          removed_countries.forEach(function (country) {
            let countryIndex = vm.model.countries.indexOf(country);
            if (countryIndex !== -1) {
              vm.model.countries.splice(countryIndex, 1);
            }
          })
        }

        return countries;
      }
    },
    async beforeMount() {
      let loader = this.$loading.show();
      let vm = this;

      var promises = [];

      var profileRequest;
      if (this.userId) {
        profileRequest = UserService.getUserProfileData(this.userId);
      } else {
        profileRequest = UserService.getProfileData();
      }

      let promiseUser = profileRequest.then((response) => {
        this.model = {...this.model, ...response.data};
        if (!this.model.profile) {
          this.model.profile = {};
        }
        if (!this.model.fields) {
          this.model.fields = {};
        }
      })

      let promiseRegion = RegionService.getRegionsWithCountries().then(function (response) {
        vm.regions = response.data;
      })

      if(vm.loggedUser.role === UserRoles.ADMIN) {
        let promiseAllApplicationsLight = ApplicationService.getAllApplicationsLight().then(function (response) {
          vm.allApplicationsLight = response.data;
        })

        promises.push(promiseAllApplicationsLight);
      }

      promises.push(promiseUser);
      promises.push(promiseRegion);

      await Promise.all(promises);

      if (vm.model.countries.length) {
        vm.model.access_type = 'countries';
      } else if (vm.model.assignedApplications.length) {
        vm.model.access_type = 'applications';
      }

      vm.initialized = true;
      loader.hide();
    },
    methods: {
      countriesByRegion: function (regionId) {
        let countries = [];
        let region = this.regions.filter((region) => {
          return region.regionId === regionId;
        });
        if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length) {
          countries = region[0].countries;
        }
        return countries;
      },
      setRegion(event) {
        this.model.fields.regionId = parseInt(event.target.value);
        this.model.fields.countryId = [];
      },
      setCountry(event) {
        this.model.fields.countryId = parseInt(event.target.value);
      },
      async updateProfile() {
        let vm = this;
        let isValidForm;

        if (this.loggedUser.id === this.model.profile.id) {
          isValidForm = await this.$validator.validateAll();
        } else {
          isValidForm = true;
        }

        switch (vm.model.access_type) {
          case 'countries':
            vm.model.assignedApplications = [];
            break;

          case 'applications':
            vm.model.countries = [];
            break;
        }

        if (isValidForm) {
          let loader = this.$loading.show();

          var updateRequest;
          if (this.userId) {
            updateRequest = UserService.updateUserProfileData(this.model, this.userId);
          } else {
            updateRequest = UserService.updateProfileData(this.model);
          }

          await updateRequest.then(() => {
            this.$store.dispatch('Auth/init');
            LocalizationService.init();

          }).catch(() => {

          });

          loader.hide();
        }
      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      }
    }
  };
</script>
<style scoped lang="scss">
  .radio-component {
    margin-bottom: 0.2rem !important;
  }
</style>
